import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';
import { rescueLevelActivateFromOA } from './rescueLevel.modifiers';

export const rescueLevelCheats = createActions({
  cheat_rescueLevelActivateCrocodile: action((state) => {
    rescueLevelActivateFromOA(state, '2026-07-21-rescue_crocodile');
  }),
  cheat_rescueLevelActivateFrozen: action((state) => {
    rescueLevelActivateFromOA(state, '2026-07-22-frozen_rescue');
  }),
  cheat_rescueLevelReset: action((state) => {
    delete state.rescueLevel;
  }),
});
